import { render, staticRenderFns } from "./UserAgreement-Android.vue?vue&type=template&id=34ce3c7c&scoped=true"
import script from "./UserAgreement-Android.vue?vue&type=script&lang=js"
export * from "./UserAgreement-Android.vue?vue&type=script&lang=js"
import style0 from "./UserAgreement-Android.vue?vue&type=style&index=0&id=34ce3c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ce3c7c",
  null
  
)

export default component.exports